import { useContext } from 'react';
import { Text, Box, useBreakpointValue } from '@chakra-ui/react';
import { ICON_BY_NAME } from '../../Icons/Icon';
import { CbTooltip } from '../../CbTooltip';
import { CbAvatar } from '../../CbAvatar';
import style from './CommentItem.module.css';
import { NewsfeedSettingsContext } from 'providers';
import { Comment } from 'types/Comment';
interface CommentsProps {
  isTopComment: boolean;
  itemAge: string;
  openDeleteModal: (isOpen: boolean) => void;
  user: Comment['user'];
}
const CommentHeader = ({
  user,
  isTopComment,
  itemAge,
  openDeleteModal
}: CommentsProps) => {
  const {
    canDeleteComments
  } = useContext(NewsfeedSettingsContext);
  const isMobile = useBreakpointValue({
    base: true,
    sm: false
  }, {
    ssr: false
  });
  return <Box className={style.commentHeader} data-sentry-element="Box" data-sentry-component="CommentHeader" data-sentry-source-file="CommentHeader.tsx">
      <Box className={style.commentNameContainer} data-sentry-element="Box" data-sentry-source-file="CommentHeader.tsx">
        <CbAvatar image={user.imageUrl} size="sm" data-sentry-element="CbAvatar" data-sentry-source-file="CommentHeader.tsx" />
        <Box data-sentry-element="Box" data-sentry-source-file="CommentHeader.tsx">
          <Text fontSize="sm" as="b" className={style.commentText} data-sentry-element="Text" data-sentry-source-file="CommentHeader.tsx">
            {user.name}
          </Text>
          <Text fontSize="xs" className={style.date} data-sentry-element="Text" data-sentry-source-file="CommentHeader.tsx">
            {itemAge}
          </Text>
        </Box>
      </Box>
      <Box className={style.commentBadgeSection} data-sentry-element="Box" data-sentry-source-file="CommentHeader.tsx">
        {isTopComment && <Box className={isMobile ? style.topCommentBadgeContainerMobile : style.topCommentBadgeContainer}>
            <Text fontSize={'xs'} className={style.topComment}>
              Top Comment
            </Text>
          </Box>}
        {canDeleteComments && <Box className={style.actionMenu}>
            <CbTooltip backgroundColor="white" color="cloud.900" content={<button onClick={() => openDeleteModal(true)}>
                  {'Delete Comment'}
                </button>}>
              <button>
                <ICON_BY_NAME.dotshorizontal width="100%" minWidth={'0px'} fontSize={16} />
              </button>
            </CbTooltip>
          </Box>}
      </Box>
    </Box>;
};
export default CommentHeader;